<template>
  <div class="sidebar-position" v-bind:class="isClicked" @click="changeScreen">
    <i class="fas" v-bind:class="active"></i>
    <input type="checkbox" name="handleClick" class="sidebar-button" v-model="checked" @click="handleClick" />
  </div>
</template>

<style lang="scss">
  .sidebar-position {
    position: absolute;
    z-index: 200000;
    background-color: #03B6FC;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 2px 0px 0px 2px;
    vertical-align: center;
    top: 6%;
    left: 0;
    width: 20px;
    transition: all 400ms ease-out;
    -webkit-transition: all 400ms ease-out;
    -moz-transition: all 400ms ease-out;
    -webkit-transform: translate(-1%, -50%);
    -moz-transform: translate(-1%, -50%);
    transform: translate(-103%);
    &.go-right {
      background-color: $white;
    }
    .sidebar-button {
      width: 100%;
      height: 50px;
      opacity: 0;
      border: none;
      cursor: pointer;
      border-left: 1px solid #D4D4D4;
      &:checked {
        background-color: $white;
      }
    }
    .fas {
      font-size: 18px;
      cursor: pointer;
    }
    .fa-chevron-right {
      color: #8F95A2;
      position: absolute;
      bottom: 50%;
      right: 50%;
      transform: translate(50%, 50%);
    }
    .fa-chevron-left {
      color: $white;
      position: absolute;
      bottom: 50%;
      right: 50%;
      transform: translate(50%, 50%);
    }
  }
</style>

<script>
import { TweenMax, Power3 } from 'gsap';

export default {
  name: 'Sidebar-Toggle-After-Timer',
  data() {
    return {
      checked: false,
      right: '',
      isClicked: null,
      active: 'fa-chevron-left',
      opened: 'fa-chevron-left',
      closed: 'fa-chevron-right',
    };
  },
  props: {
    JourneyEnd : {
      type: Boolean
    }
  },
  watch: {
    JourneyEnd: {
      handler(val) {
        this.JourneyEnd = val;
        if (this.JourneyEnd == true && this.open == true) {
          this.$store.dispatch('toggleSidebarAfterTimer');
          this.active = this.opened;
          this.isClicked = null;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    show() {
      return this.$store.state.ui.sidebarReactivate;
    }
  },
  methods: {
    changeScreen() {
      this.JourneyEnd = !this.JourneyEnd;
      this.$emit('unDisableScreen', this.JourneyEnd);
    },
    handleClick() {
      if (this.JourneyEnd == true) {
        this.$store.dispatch('toggleSidebarAfterTimer');
        if (this.checked === true) {
          this.active = this.opened;
          this.isClicked = null;
        } else {
          this.active = this.closed;
          this.isClicked = 'go-right';
        }
      }
    }
  }
}
</script>
